export class Log {
  static info(message: string, context?: Record<string, any>) {
    console.info(message, context);
  }

  static error(message: string, error?: Error | unknown, errorType?: string, context?: Record<string, any>) {
    console.error(message, error, { type: errorType, ...context });
  }

  static warn(message: string, context?: Record<string, any>) {
    console.warn(message, context);
  }

  static debug(message: string, context?: Record<string, any>) {
    console.debug(message, context);
  }
} 